var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76135 0.723467L9.23751 2.70985C9.71601 2.95646 10 3.48597 10 4V8C10 8.51403 9.71601 9.04355 9.23751 9.29015L5.76135 11.2765C5.30072 11.5745 4.69928 11.5745 4.23865 11.2765L0.762488 9.29015C0.28399 9.04355 0 8.51403 0 8V4C0 3.48597 0.28399 2.95645 0.762487 2.70985L4.23865 0.723467C4.69928 0.425511 5.30072 0.425511 5.76135 0.723467ZM5.22265 1.56603C5.0906 1.47799 4.9094 1.47799 4.77735 1.56603C4.7678 1.57239 4.75803 1.57843 4.74807 1.58412L1.52471 3.42604L4.99999 5.42333L8.47528 3.42604L5.25193 1.58412C5.24197 1.57843 5.2322 1.57239 5.22265 1.56603ZM1 8V4.27787L4.5 6.28937V10.2741L1.24807 8.41588C1.24004 8.41129 1.23188 8.40692 1.22361 8.40279C1.1105 8.34623 1 8.18101 1 8ZM5.5 10.2741L8.75193 8.41588C8.75996 8.41129 8.76812 8.40692 8.77639 8.40279C8.8895 8.34623 9 8.18101 9 8V4.27786L5.5 6.28935V10.2741Z",
    fill: "#787A84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApis);
export default __webpack_public_path__ + "static/media/apis.f9deb5c3.svg";
export { ForwardRef as ReactComponent };